/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import { Injectable } from "@angular/core";

/**
 * @experimental WebWorker support in Angular is currently experimental.
 */
export const enum SerializerTypes {
  // RendererType2
  RENDERER_TYPE_2,
  // Primitive types
  PRIMITIVE,
  // An object stored in a RenderStore
  RENDER_STORE_OBJECT,
}

/**
 * Any type that does not need to be serialized (string, number, boolean)
 *
 * @experimental WebWorker support in Angular is currently experimental.
 */
export const PRIMITIVE = SerializerTypes.PRIMITIVE;

export class LocationType {
  constructor(
    public href: string,
    public protocol: string,
    public host: string,
    public hostname: string,
    public port: string,
    public pathname: string | null,
    public search: string,
    public hash: string,
    public origin: string,
  ) {}
}

@Injectable()
export class Serializer {
  serialize(obj: any, type: any): object {
    if (obj == null || type === SerializerTypes.PRIMITIVE) {
      return obj;
    }
    if (Array.isArray(obj)) {
      return obj.map((v) => this.serialize(v, type));
    }
  }

  deserialize(map: any, type: any, data?: any): any {
    if (map == null || type === SerializerTypes.PRIMITIVE) {
      return map;
    }
    if (Array.isArray(map)) {
      return map.map((val) => this.deserialize(val, type, data));
    }
  }
}
